import axios from 'axios'
import wcs from '@/scripts/libs/wcs'
import qs from 'qs'
import { WcsEspotResponse } from '@/scripts/libs/wcs/types/wcs-config'

type ContactInformation = {
  reasons: Array<ContactReason>
}

type ContactReason = {
  type: string
  channels: Array<ContactChannel>
}

export type ContactChannel = CtaChannel | PhoneChannel | ChatChannel | EmailChannel

export interface HoursOfOperation {
  day: string
  displayDay: string
  hours: { start: string; end: string; timezone: string }
}

export interface FormattedHoursOfOperation extends HoursOfOperation {
  formattedHours: string
}

type CtaChannel = {
  type: 'cta'
  link?: string
  linkType?: string
  labels: Array<Record<string, string>>
}

type PhoneChannel = {
  type: 'phone'
  number: string
  hoursOfOperation: Array<HoursOfOperation>
  callBack: boolean
  labels: Array<Record<string, string>>
}

type ChatChannel = {
  type: 'chat'
  link: undefined | string
  hoursOfOperation: Array<HoursOfOperation>
  labels: Array<Record<string, string>>
}

type EmailChannel = {
  type: 'email'
  isFallback: boolean
}

interface WcsContactForm {
  subject: string
  name: string
  surname: string
  email: string
  message: string
  ordernumber: string
  topic: string
  attachmentFileName?: string
  attachmentBase64?: string
  phone?: string
}

export class WcsContactUs {
  static fetchContactOptions = async (): Promise<ContactInformation> => {
    const endpoint = wcs.getEndPoint('contactUsConfiguration')
    const { data }: { data: WcsEspotResponse<string> } = await axios.get(endpoint)

    return JSON.parse(
      data?.MarketingSpotData[0]?.baseMarketingSpotActivityData[0]?.marketingContentDescription[0]
        ?.marketingText
    ) as ContactInformation
  }

  static submitContactForm = async (endpoint: string, formData: WcsContactForm) => {
    const { catalogId, storeId, langId } = wcs.getStoreConfig()

    const data = {
      dropbox: formData.subject,
      firstName: formData.name,
      lastName: formData.surname,
      email: formData.email,
      textMessage: formData.message,
      orderId: formData.ordernumber,
      topic: formData.topic,
      attachmentFileName: formData.attachmentFileName,
      attachmentBase64: formData.attachmentBase64,
      phone: formData.phone,
      storeId,
      catalogId,
      langId,
    }

    try {
      const result = await axios.post(endpoint, data, {
        withCredentials: true,
      })
      return { ...result.data, success: true }
    } catch (e) {
      if (e instanceof Error) {
        return { error: e.message, success: false }
      }
    }
  }

  static emailMe = async (data: unknown) => {
    const emailMeUrl = 'SendPreOrderEmail'
    const response = await axios.post(emailMeUrl, qs.stringify(data))
    return response.data
  }
}
